import { render, staticRenderFns } from "./FundaBNPLInsurCheck.vue?vue&type=template&id=b548a2d4&scoped=true&"
import script from "./FundaBNPLInsurCheck.vue?vue&type=script&lang=js&"
export * from "./FundaBNPLInsurCheck.vue?vue&type=script&lang=js&"
import style0 from "./FundaBNPLInsurCheck.vue?vue&type=style&index=0&id=b548a2d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b548a2d4",
  null
  
)

export default component.exports